document.addEventListener('click', async (event) => {
  const widget = event.target.closest('[data-pick3-sale]');
  if (!widget) return;
  const remaining = Number(widget.dataset.pick3Remaining);

  const carousel = widget.querySelector('[data-pick3-carousel]');
  if (event.target.closest('[data-pick3-prev]')) {
    carousel.scrollBy({ left: -240, behavior: 'smooth' });
    return;
  }
  if (event.target.closest('[data-pick3-next]')) {
    carousel.scrollBy({ left: 240, behavior: 'smooth' });
    return;
  }

  const card = event.target.closest('[data-pick3-variant]');
  if (card) {
    const selected = widget.querySelectorAll('[data-pick3-variant][aria-pressed="true"]');
    if (card.getAttribute('aria-pressed') === 'true') {
      card.setAttribute('aria-pressed', 'false');
    } else if (selected.length < remaining) {
      card.setAttribute('aria-pressed', 'true');
    }
    const count = widget.querySelectorAll('[data-pick3-variant][aria-pressed="true"]').length;
    widget.querySelector('[data-pick3-count]').textContent = `${count} of ${remaining} selected`;
    widget.querySelector('[data-pick3-add]').disabled = count !== remaining;
    return;
  }

  const addButton = event.target.closest('[data-pick3-add]');
  if (!addButton || addButton.disabled) return;
  const ids = [...widget.querySelectorAll('[data-pick3-variant][aria-pressed="true"]')]
    .map((selectedCard) => Number(selectedCard.dataset.pick3Variant));
  if (ids.length !== remaining) return;

  addButton.disabled = true;
  addButton.textContent = 'Adding your items…';
  const error = widget.querySelector('[data-pick3-error]');
  error.hidden = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: ids.map((id) => ({ id, quantity: 1 })),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error('Could not add the selected items. Please try again.');
    const result = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && result.sections && result.sections['cart-drawer']) {
      drawer.renderContents(result);
    } else {
      window.location.reload();
    }
  } catch (failure) {
    error.textContent = failure.message;
    error.hidden = false;
    addButton.disabled = false;
    addButton.textContent = `Add ${remaining} free ${remaining === 1 ? 'item' : 'items'} to cart`;
  }
});
